import { combineReducers } from 'redux';
import select from 'block/select/reducer';
import sports from 'block/sports/reducer';
import tournaments from 'block/tournaments/reducer';
import checked from 'block/checked/reducer';
import modal from 'block/modal/reducer';
import tasks from 'block/tasks/reducer';
import modalDialog from 'block/modal-dialog/reducer';
import progressBar from 'block/progress-bar/reducer';

export default combineReducers({
    select,
    sports,
    tournaments,
    checked,
    modal,
    tasks,
    modalDialog,
    progressBar
});



// WEBPACK FOOTER //
// ./src/reducers.js